import { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Papa from 'papaparse';
import Cart from './Cart';
import { CartContext } from '../CartContext';
import { ImCheckmark } from "react-icons/im";
import { images } from './axAdult';
import ResizableImage from './ResizableComponent';
import { HiOutlineMagnifyingGlassPlus, HiMagnifyingGlassMinus } from "react-icons/hi2";
import SanmarImages from './SanmarImages';
import CompatibleSlider from './CompatibleSlider';
import SubPics from './SubPics';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { productDb } from '../firebaseProducts';
const ProductDetailAdult = ({ product }) => {
  const { style } = useParams();
  const [message, setMessage] = useState('');
  const [sellType, setSellType] = useState("");
  const [variants, setVariants] = useState([]);
  const [color, setColor] = useState('');
  const [color2, setColor2] = useState('');
  const [Url, setURL] = useState('')
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null); 
  const [myImage, setMyImage] = useState('');
  const [show2, setShowTime2] = useState(false);
  const [thumId, setThumId] = useState('')
  const [variants2, setVariants2] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [show, setShow] = useState(true);
  const [price, setPrice] = useState("")
  const [id, setId] = useState("")
  const [selectedImage, setSelectedImage] = useState(null);
  const [, setImageSize] = useState("")
  const [selectedThumPrice, setselectedThumPrice] = useState("")
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [, setIsOpen] = useState(false);
  const [, setHoveredHex] = useState(null);
  const [selectedThumbnail, ] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [initialMousePosition, setInitialMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false)
  const [isVisible2, setIsVisible2] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(null);
  const [, setUploadedImagePosition] = useState({ top: '40%', left: '50%' });
  const [initialImagePosition, setInitialImagePosition] = useState({ top: 0, left: 0 });
  const [initialTouchPosition, setInitialTouchPosition] = useState({ x: 0, y: 0 });
  const [priceIn, setPriceIn] = useState(false)
  const [showTime, setShowTime] = useState(false)
  const [searchQuery, setSearchQuery] = useState('');
  const [isZoomed, setIsZoomed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [url, setUrl] = useState(null)
  const ref = useRef(null)
  const navigate = useNavigate()
  const [csvData, setCsvData] = useState([]);
  // const [capturedImage, setCapturedImage] = useState(null);
  const mySrc = `https://www.wearandwonder.shop/documents/details/${style}_productmeasurement.pdf`
  const handleClick = (url) => setSelectedImage(url);
  let myTotal=0

  const embellishmentOnlyBrands = [
    "Brooks Brothers",
    "New Era",
    "Outdoor Research",
    "The North Face",
    "Carhartt",
    "Nike",
    "Stanley/Stella",
    "Tommy Bahama",
    "Cotopaxi",
    "OGIO",
    "tentree",
    "Travis Mathew",
    "Eddie Bauer"
  ];

  const isEmbellishmentOnly = (vendor) => {
    return embellishmentOnlyBrands.some(
      (brand) => brand.toLowerCase() === vendor?.trim().toLowerCase()
    );
  };
        useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [uploadedImage]);
//   useEffect(() => {
//     // console.log("1")
//     const csvUrl = '../full-adult-apparel-base.csv';
//     // const csvUrl = '../fullKids.csv';
//     setUrl(csvUrl)
//     fetch(csvUrl)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error('Failed to load CSV file');
//         }
//         return response.text();
//       })
//       .then((csvData) => {
//         Papa.parse(csvData, {
//           complete: (result) => {
//             const data = result.data;
//             const today = new Date();

//             const filteredVariants = data
//               .slice(1)
//               .filter((item) => item[13] === style)
//               .map((item) => {
//                 const parseDate = (dateStr) => {
//                   if (!dateStr) return null;
//                   const [month, day, year] = dateStr.split('/').map(Number);
//                   return new Date(year, month - 1, day);
//                 };

//                 const endSaleDate = parseDate(item[52]);
//                 const isOnSale = endSaleDate && endSaleDate >= today;

//                 const price = parseFloat(item[1]) || 0;
//                 const salePrice = parseFloat(item[48]) || 0;



//                 let adjustedSalePrice = salePrice;

//                 //optione fagat $3 off inja tarif mishe
//                 if (isOnSale && salePrice > 0) {
//                   const discount = price - salePrice;
//                   if (discount > 3) {
//                     adjustedSalePrice = price - 3;
//                   }
//                 }

//                 return {
//                   Handle: item[29],
//                   DefaultImageSrc: item[36],
//                   HoverImageSrc: item[24],
// FRONT_FLAT:item[24],
// BACK_FLAT:item[25],
// FRONT_MODEL:item[55],
// BACK_MODEL:item[56],
// SIDE_MODEL:item[57],
// THREE_Q_MODEL:item[59],
// model:item[36],
// back:item[23],
// front:item[22],
// ImageSrc:item[2],
//                   Price: price.toFixed(2),
//                   Description: item[3],
//                   Color: item[7],
//                   Size: item[17],
//                   Style: item[13],
//                   Hex: item[30],
//                   ColorName: item[7],
//                   ProductDetail: item[26],
//                   ProductDecor: item[27],
//                   Id: item[34],
//                   Vendor: item[4],
//                   tag: item[35],
//                   EndSale: endSaleDate,
//                   isOnSale,
//                   SalePrice: adjustedSalePrice.toFixed(2),
//                   weight: item[38],
//                   colorName4API: item[58],
//                   ImageCircle: item[61], // column 62


//                 };
//               })
//             // .filter((variant) => variant.Hex && /^#[0-9A-F]{6}$/i.test(variant.Hex)); // Only valid hex values

//             setVariants(filteredVariants);
//             setLoading(false);

//             if (filteredVariants.length > 0) {
//               setSelectedVariant(filteredVariants[0]);
//               setMyImage(filteredVariants[0].DefaultImageSrc); // <- use filteredVariants[0] here
//               setPrice(filteredVariants[0].Price)
//             }
//           },
//           header: false,
//           skipEmptyLines: true,
//         });
//       })
//       .catch((err) => {
//         setError(err.message);
//         setLoading(false);
//       });
//   }, [style]);

//firestore version
useEffect(() => {
  // console.log("🔥 useEffect triggered with style:", style);
  const fetchVariants = async () => {
    try {
      // console.log("🚀 Fetching from Firestore…");
  const q = query(
    collection(productDb, 'adult-apparel'), 
    where('Style', '==', style)
  );
  // console.log("🧐 Querying with style:", style); // Log style
  const querySnapshot = await getDocs(q);
  // console.log("querySnapshot size:", querySnapshot.size);

  // querySnapshot.forEach(doc => {
  //   console.log("🔥 Doc:", doc.id, doc.data());
  // });

      const today = new Date();

      const filteredVariants = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        // Parse SALE_END_DATE from string to Date object (if it's not 0)
        let endSaleDate = null;
        if (data.SALE_END_DATE && data.SALE_END_DATE !== '0') {
          endSaleDate = new Date(data.SALE_END_DATE);
        }

        // Check if the item is on sale
        const isOnSale = endSaleDate && endSaleDate >= today;

      const price = Math.round((parseFloat(data.Price) + 5) * 100) / 100;
const salePrice = Math.round((parseFloat(data.salePrice) + 5) * 100) / 100;
        let adjustedSalePrice = salePrice;

        if (isOnSale && salePrice > 0) {
          const discount = price - salePrice;
          if (discount > 3) adjustedSalePrice = price - 3;
        }

        return {
          Handle: data.Handle,
          DefaultImageSrc: data.model,  // Assuming 'model' is the correct field
          HoverImageSrc: data.FRONT_FLAT,
          FRONT_FLAT: data.FRONT_FLAT,
          BACK_FLAT: data.BACK_FLAT,
          FRONT_MODEL: data.FRONT_MODEL,
          BACK_MODEL: data.BACK_MODEL,
          SIDE_MODEL: data.SIDE_MODEL,
          model: data.DefaultImageSrc,
          front: data.front,
          back: data.back,
          ImageSrc: data.ImageSrc,

          Price: price.toFixed(2),
          SalePrice: adjustedSalePrice.toFixed(2),
          isOnSale,
          EndSale: endSaleDate,
          Description: data.Body,  // Assuming you want the 'Body' field here
          Color: data.Color,
          Size: data.Size,
          Style: data.Style,
          Hex: data.Hex,
          Vendor: data.Vendor,
          Id: data.id,  // Assuming 'id' is the correct field
          tag: data.Tags,  // Assuming 'Tags' is the correct field
          ProductDetail: data.ProductDetail,
          ProductDecor: data.ProductDecor,
          weight: data.Weight,
          colorName4API: data.colorName4API,
          ImageCircle: data.ImageCircle,
        };
      });

      setVariants(filteredVariants);
      setLoading(false);

      if (filteredVariants.length > 0) {
        setSelectedVariant(filteredVariants[0]);
        setMyImage(filteredVariants[0].DefaultImageSrc);
        setPrice(filteredVariants[0].Price);
      }
    } catch (err) {
      console.error("Error fetching variants:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  fetchVariants();
}, [style]);


  const swatchImages = Array.from(
    new Map(
      variants
        .filter((v) => v.Style === style)
        .map((v) => [v.Color, v.ImageCircle]) // key: color, value: image
    )
  );
  // useEffect(() => {
  //    console.log("2")
  //   const fetchCSV = async () => {
  //     const response = await fetch(`${url}?t=${Date.now()}`, { cache: "no-store" });
  //     const csvText = await response.text();
  //     const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
  //     setCsvData(parsed.data);
  //   };
  //   fetchCSV();
  // }, [url]);
  useEffect(() => {
    //  console.log("3")
    if (!selectedVariant) return;

    const result = isEmbellishmentOnly(selectedVariant?.Vendor)
      ? "Sold by Embellishment Only"
      : "Can be Sold Blank";

    setSellType(result);
    if (result === "Can be Sold Blank") {
      setPriceIn(true);
    }


  }, [selectedVariant]);

  useEffect(() => {
    //  console.log("4")
    if (variants.length > 0 && !selectedColor) {
      const firstHex = [...new Set(variants.map((variant) => variant.Hex))][0];
      setSelectedColor(firstHex);
      const matchedVariant = variants.find(variant => variant.Hex === firstHex);
      if (matchedVariant) {
        // console.log(matchedVariant.Color)

        setColor2(matchedVariant.Color); // <- set the color name state here
      }
    }
  }, [variants]);

  const handleMouseMove = (e) => {
    if (isDragging) {
      const deltaX = e.clientX - initialMousePosition.x;
      const deltaY = e.clientY - initialMousePosition.y;
      const containerRect = ref.current.getBoundingClientRect();
      const newTop = initialImagePosition.top + deltaY;
      const newLeft = initialImagePosition.left + deltaX;
      const clampedTop = Math.min(Math.max(newTop, 0), containerRect.height - 100);
      const clampedLeft = Math.min(Math.max(newLeft, 0), containerRect.width - 100);
      setUploadedImagePosition({ top: `${clampedTop}px`, left: `${clampedLeft}px` });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    if (isDragging) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - initialTouchPosition.x;
      const deltaY = touch.clientY - initialTouchPosition.y;
      const containerRect = ref.current.getBoundingClientRect();
      const newTop = initialImagePosition.top + deltaY;
      const newLeft = initialImagePosition.left + deltaX;
      const clampedTop = Math.min(Math.max(newTop, 0), containerRect.height - 100);
      const clampedLeft = Math.min(Math.max(newLeft, 0), containerRect.width - 100);
      setUploadedImagePosition({ top: `${clampedTop}px`, left: `${clampedLeft}px` });
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    //  console.log("5")
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDragging, initialMousePosition, initialTouchPosition, initialImagePosition]);

  // Attach event listener for outside click
  useEffect(() => {
    //  console.log("6")
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev)
    setIsVisible2(false)
  }

  const handleVariantChange = (e, type) => {
    const selectedValue = e.target.value;
    setIsOpen(false);
    // setUploadedImage(null);

    let newColor = selectedColor;
    let newSize = selectedSize;

    if (type === 'Hex') {
      newColor = selectedValue;
      setSelectedColor(newColor);
    } else if (type === 'Size') {
      newSize = selectedValue;
      setSelectedSize(newSize);
      setShowTime(true);
      setShowTime2(true);
    }

    // Always find the variant that matches both color and size
    const updatedVariant = variants.find(
      (variant) => variant.Color === newColor && variant.Style === style && variant.Size === newSize
    );
    // console.log(updatedVariant,newColor,color2)
    if (updatedVariant) {
      // console.log(variants)
      setSelectedVariant(updatedVariant);
      const v = variants.filter((item) => item.Id === updatedVariant.Id);
      setVariants2(v);
      setId(updatedVariant.Id)
      setPrice(updatedVariant.Price);
      // Set color name based on the matching variant
      const matchedVariant = variants.find(variant => variant.Hex === newColor);
      if (matchedVariant) {
        setColor2(matchedVariant.Color);
        setSelectedImage(matchedVariant.DefaultImageSrc)
      }
    }
  };
  const handleThumbnailClick = async (image, position) => {
    alert("You can resize the image by clicking and dragging it into position. If you don't adjust it, the default width for a full front print is 10 inches. Click outside the image to deselect it.")
    // console.log(selectedVariant.tag)
    if (selectedVariant.tag === "Youth,Sweatshirts/Fleece") {
      setImageSize("16%")
    }
    if (selectedVariant.tag === "Youth,T-Shirts") {
      setImageSize("25%")
    }
    if (selectedVariant.tag === "Youth,Caps") {
      setImageSize("19%")
    }
    if (selectedVariant.tag === "Infant & Toddler,T-Shirts") {
      setImageSize("22%")
    }
    if (selectedVariant.tag === "Infant & Toddler,Zipper") {
      setImageSize("15%")
    }
    if (selectedVariant.tag === "pants") {
      setImageSize("15%")
    }
    if (selectedVariant.tag === "polos") {
      setImageSize("13%")
    }
    if (selectedVariant.tag === "Zipper") {
      setImageSize("13%")
    }
    setId(selectedVariant.Id)
    if (selectedSize === "") {
      alert("You have not selected any size!")
      return
    }
    setselectedThumPrice(image.Alt);
    setThumId(image.id)
    setUploadedImage(image.src);
    setPrice(selectedVariant.Price)
    setPriceIn(true)
    const payamurl = selectedVariant.DefaultImageSrc
    setURL(payamurl)

    const response = await fetch("https://api-shipping-28612190fdf4.herokuapp.com/image", {
      // const response = await fetch("http://localhost:4000/image", {
      method: "POST",
      body: JSON.stringify({ imageUrl: payamurl }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        document.getElementById('myImage').style.backgroundImage = 'url(' + data.image + ')';
        // document.getElementById('magnifying-glass').style.display = 'none';
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };
  const handleSubmit = async (base64Image, chunkSize = 50000) => {
    const totalChunks = Math.ceil(base64Image.length / chunkSize);
    // console.log(totalChunks)
    for (let i = 0; i < totalChunks; i++) {
      const chunk = base64Image.slice(i * chunkSize, (i + 1) * chunkSize);

      const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/customerimage', {
        // const response = await fetch('http://localhost:4000/customerimage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Explicitly set the content type to JSON
        },
        body: JSON.stringify({
          chunk,
          chunkIndex: i,
          totalChunks // Sending base64 image as JSON payload
        }),
      });

      const result = await response.json();
      if (response.ok) {
        console.log('Image uploaded successfully:'
          // , result.url
        ); // `url` key in the response
      } else {
        console.error('Error uploading image:', result.message);
      }

    }

  };
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });

  const uploadImageToCloudinary = async (base64File, fileType) => {
    try {
      const resourceType =
        fileType && fileType.toLowerCase() === "image/png" ? "image" : "raw";
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/dcuturlmb/${resourceType}/upload`,
        {
          method: "POST",
          body: new URLSearchParams({
            file: base64File,
            upload_preset: "ml_default",
          }),
        }
      );
      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null;
    }
  };
  const uploadLargeToCloudinary = async (file, chunkSize = 6 * 1024 * 1024) => {
    const resourceType =
      file.type && file.type.toLowerCase() === "image/png" ? "image" : "raw";
    const url = `https://api.cloudinary.com/v1_1/dcuturlmb/${resourceType}/upload`;
    const uploadPreset = "ml_default";

    let start = 0;
    let end = chunkSize;
    let part = 0;
    let uploadId = `${Date.now()}-${Math.random()}`;
    let finalResult = null;

    while (start < file.size) {
      const chunk = file.slice(start, end);
      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("upload_preset", uploadPreset);
      formData.append("upload_id", uploadId);
      formData.append("part_number", part + 1);

      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          "X-Unique-Upload-Id": uploadId,
          "Content-Range": `bytes ${start}-${end - 1}/${file.size}`,
        },
      });

      const data = await response.json();
      if (data.error) throw new Error(data.error.message);

      finalResult = data;
      start = end;
      end = start + chunkSize;
      part++;
    }

    return finalResult?.secure_url;
  };
const handleFileChange = async (event) => {
  setPriceIn(true);
  setPrice(selectedVariant.Price);
  setId(selectedVariant.Id);
  setselectedThumPrice("15");

  const file = event.target.files[0];
  if (!file) return;

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB limit
  if (file.size > MAX_FILE_SIZE) {
    alert("File too large. Maximum allowed size is 10 MB.");
    event.target.value = "";
    return;
  }

  // Allowed MIME types
const allowedTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "application/pdf",
  "application/zip",
  "application/x-zip-compressed",
  "multipart/x-zip",
  "application/x-zip",
];

  // Allowed extensions for AI/CDR/PSD
 const allowedExtensions = ["ai", "cdr", "psd", "zip"];
  const fileExtension = file.name.split(".").pop().toLowerCase();

if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
  alert("Invalid file type. Allowed: PNG, JPG, JPEG, GIF, PDF, AI, CDR, PSD, ZIP");
  event.target.value = "";
  return;
}

  const colorName = variants.find((v) => v.Hex === selectedColor)?.ColorName;
  setColor(colorName);

  try {
    let uploadedUrl = null;

    if (file.size > 20 * 1024 * 1024) {
      uploadedUrl = await uploadLargeToCloudinary(file);
    } else {
      const base64Data = await fileToBase64(file);
      uploadedUrl = await uploadImageToCloudinary(base64Data, file.type);
    }

    if (uploadedUrl) {
      // Save URL for backend usage
      setUploadedFileUrl(uploadedUrl);

      // Only show preview for images
      if (["image/png", "image/jpeg", "image/jpg", "image/gif"].includes(file.type)) {
        setUploadedImage(uploadedUrl);
      } else {
        setUploadedImage(null); // no preview
      }

      setThumId("Personal");
    }
  } catch (err) {
    console.error("Upload failed:", err);
    alert("File upload failed. Try again.");
  }
};

   myTotal = (parseFloat(price)).toFixed(2)

  const products = [
    {
      id: id, title: `${style}`, name: `${style}`, price: `${parseFloat(myTotal)}`,
      Thum_Price: `${selectedThumPrice}`, size: `${selectedSize}`, colorHex: `${selectedColor}`
      , color: `${color}`,
      //  image:`${capturedImage}`,
      thumImage: `${uploadedImage}`,thumFile:`${uploadedFileUrl}`, thumId: `${thumId}`,
      image2: `${Url}`, image3: `${myImage}`, rating: `${0}`
    }
  ];
  // console.log(products)
  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter images based on the search query (case-insensitive)
  // const filteredImages = images.filter((image) =>
  //   image.src.toLowerCase().includes(searchQuery.toLowerCase())

  // );
  //   const filteredImages = images.filter((image) => {
  //   const normalizedSrc = image.src.replace(/-/g, ' ').toLowerCase();
  //   const words = searchQuery.toLowerCase().split(/\s+/); // split by spaces

  //   return words.every(word => normalizedSrc.includes(word));
  // });
  const filteredImages = images.filter((image) => {
    const normalizedSrc = image.main
      .split('/').pop()
      .replace(/\.[^/.]+$/, '')    // remove file extension
      .replace(/-/g, ' ')
      .toLowerCase();

    const normalizedId = String(image.id || "").toLowerCase();

    const words = searchQuery.trim().toLowerCase().split(/\s+/);

    const matches = words.every(word =>
      normalizedSrc.includes(word) || normalizedId === word
    );

    return matches;
  });

  // sending measurement from resizable
const handleMessageFromChild = (msg) => {
  // console.log(msg)
  if (msg.widthInches > 15 || msg.heightInches > 15) {
    alert("Width or height cannot be greater than 15 inches.");
    return; // stop function if invalid
  }

  setMessage(msg);
};

  // Handle outside click to reset zoom
  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setIsZoomed(false);
    }
  }

  // Handle zoom toggle
  const toggleZoom = (e) => {
    e.stopPropagation();
    setIsZoomed(!isZoomed);

  };
  return (

    <div className="product-detail"  >

      {selectedVariant && (
        <>
          {show && (<button style={{ justifyItems: "center", marginBottom: 10, width: 250, height: 55, fontSize: 23, textAlign: "center", fontWeight: "bold", alignContent: "center" }} className="button-85">{style}</button>)}
          <p>{sellType}</p>


          <div
            className={`spotlight ${isZoomed ? 'zoomed' : ''}`}
            ref={ref}
            id="myImage"
            style={{
              backgroundImage: `url(${selectedImage || selectedVariant?.DefaultImageSrc})`,

              pointerEvents: 'auto',
              transition: 'transform 0.3s ease',
              transform: isZoomed ? 'scale(2)' : 'scale(1)',
            }}
            onMouseEnter={() => setIsHovered(true)} // When mouse enters, set hover state
            onMouseLeave={() => setIsHovered(false)} // When mouse leaves, reset hover state
          >
            {uploadedImage && (
              <>



                <ResizableImage src={uploadedImage} initialPosition={{ x: 115, y: 130 }} color={selectedVariant.Color} sendMessage={handleMessageFromChild} />

              </>)}
            <div
              className="magnifying-glass"
              id="magnifying-glass"
              style={{
                position: 'absolute',
                bottom: '15px',
                right: '10px',
                cursor: 'pointer',
                display: 'block',

                width: 20,
                height: 20,
                objectFit: "cover",
                color: isHovered ? 'grey' : 'white', // Conditional color based on hover state
              }}


            >
              {isZoomed ? (
                <HiMagnifyingGlassMinus onClick={toggleZoom} size={20} style={{ marginTop: -10, marginLeft: -2 }} />
              ) : (
                <HiOutlineMagnifyingGlassPlus onClick={toggleZoom} size={20} style={{ marginTop: -10, marginLeft: -2 }} />
              )}
            </div>
          </div>
          {selectedSize !== "" && (
          <div>
            {/* <SubPics currentStyle={style} url={url} path={"product-kids"} onImageClick={handleClick} color={color2} /> */}
            <SubPics
              currentStyle={style}
              data={variants}   // ✅ pass parsed data instead of URL
              onImageClick={handleClick}
              color={color2}
            />
          </div>
          )}
          <div className="product-info">
            <div >


              <div className="variant-options"  >
                <div className="option" style={{ marginTop: -40, color: "navy" }} >
                  <label htmlFor="size">Select Size:</label>
                  <select id="size" value={selectedSize} onChange={(e) => handleVariantChange(e, 'Size')}>
                    <option value="">Select Size</option>
                    {Array.from(new Set(variants.map((variant) => variant.Size))).map((size, index) => (
                      <option key={index} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {show2 && (

                <div className="variant-options" >
                  <div className="option">
                    <SanmarImages inputNumber={style} color={selectedVariant?.ColorName} />
                    <label htmlFor="color" style={{ marginTop: -20, color: "navy" }} >Select Color:</label>


                    <div className="color-options" style={{ padding: 10 }}>
                      {swatchImages.map(([color, imageUrl], index) => {
                        // Get the exact variant for this swatch color
                        const variant = variants.find(
                          (v) => v.Style === style && v.Color === color
                        );

                        if (!variant) return null;

                        return (
                          <div
                            key={index}
                            className="color-circle"
                            style={{
                              position: 'relative',
                              borderRadius: '50%',
                              overflow: 'hidden',
                              width: 30,
                              height: 30,
                              margin: 5,
                              cursor: 'pointer',
                              backgroundImage: `url(${imageUrl})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              border: selectedVariant.Color === color ? '2px solid black' : '1px solid #ccc',
                            }}
                            onClick={() => {

                              handleVariantChange({ target: { value: color } }, 'Hex')
                              const matchedVariant = variants.find(
                                (v) => v.Color === color && v.Style === style && v.Size === selectedSize,

                              );

                              if (matchedVariant) {
                                setSelectedVariant(matchedVariant);
                                setColor2(matchedVariant.Color);// ✅ Update selected variant
                                setSelectedImage(matchedVariant.DefaultImageSrc); // ✅ Change main image
                                setId(matchedVariant.Id);
                                setPrice(matchedVariant.Price)
                              }
                            }}
                            onMouseEnter={() => setHoveredHex(selectedVariant.Color)}
                            onMouseLeave={() => setHoveredHex(null)}
                          >
                            {/* Checkmark if selected */}
                            {selectedColor === color && (
                              <div
                                className="selected-indicator"
                                style={{
                                  position: 'absolute',
                                  top: '90%',
                                  left: '30%',
                                  transform: 'translate(-30%, -50%)',
                                  // backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '50%',
                                  padding: 0,
                                }}
                              >
                                <ImCheckmark />
                              </div>
                            )}


                          </div>
                        );
                      })}
                    </div>


                  </div>
                </div>
              )}
              <div style={{ marginTop: -10 }}>
                <h4 style={{ color: "navy" }} onClick={toggleVisibility}>
                  <i>
                    {isVisible ? "Show Less" : "Show More"}
                  </i>
                </h4>

                {isVisible && (
                  <>
                    <div
                      className="product-details2"
                      style={{ fontSize: '20px', marginLeft: '30px' }}
                      dangerouslySetInnerHTML={{ __html: selectedVariant.Description }} />
                    <div>
                      {mySrc && (
                        <h4 onClick={() => setIsVisible2(!isVisible2)}>
                          PRODUCT_MEASUREMENTS
                        </h4>
                      )}

                    </div>
                  </>
                )}
                {isVisible2 && (
                  <div className='iframe'>
                    <iframe title={style} width={300} height={200} src={mySrc}></iframe>
                    <hr></hr>
                  </div>
                )}
              </div>
              {selectedVariant && show && (
                <>
                  {/* <p className="price" style={{ color: "navy" }}>Item Price: ${parseFloat((selectedVariant.Price)).toFixed(2)}</p> */}

                  {selectedVariant.isOnSale ? (

                    <div style={{ marginBottom: 10 }}>
                      <p className="price" style={{ color: 'navy', marginBottom: 4 }}>Item Price:</p>
                      <p className="price" style={{ textDecoration: 'line-through', color: 'navy', marginBottom: 4 }}>
                        ${parseFloat(selectedVariant.Price).toFixed(2)}
                      </p>
                      <p style={{ color: 'red', fontWeight: 'bold', fontSize: 18 }}>
                        ${parseFloat(selectedVariant.SalePrice).toFixed(2)}
                      </p>
                    </div>
                  ) : (
                    <p className="price" style={{ color: "navy" }}>
                      Item Price: ${parseFloat(selectedVariant.Price).toFixed(2)}
                    </p>
                  )}
                  {showTime && (
                    <div className="sth">
                      <div className="v" style={{ width: "100%", justifyContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}>
                        <h5 style={{ color: "navy" }}>Available designs: <span style={{ fontSize: 14 }}>({filteredImages.length})</span> </h5>
                      </div>
                      <div className="product-container">
                        <div className="search-box">
                          <input
                            type="text"
                            placeholder="What you looking for..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                          />
                        </div>
                        <div className="product">
                          {/* <div className="product-thumbnails">
                            {filteredImages.map((image, index) => (
                              <div
                                key={index}
                                className="thumbnail"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleThumbnailClick(image)}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                              >
                                <img id="ax" src={image.src} alt={image.id} />
                                {hoveredIndex === index && (
                                  <div className="alt-text">{image.name}</div>
                                )}
                              </div>
                            ))}
                          </div> */}
                          {/* {searchQuery.trim() !== "" && ( */}
                            <div className="product-thumbnails">
                              {filteredImages.map((image, index) => (
                                <div
                                  key={index}
                                  className="thumbnail"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleThumbnailClick(image)}
                                  onMouseEnter={() => setHoveredIndex(index)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                >
                                  <img
                                    id={`img-${index}`}
                                    src={image.src}
                                    alt={image.name || "Product image"}
                                  />
                                  {hoveredIndex === index && (
                                    <div className="alt-text">{image.name}</div>
                                  )}
                                </div>
                              ))}
                            </div>
                          {/* )} */}
                        </div>
                      </div>
                      <div className="fileInput" >
                        <label style={{ color: "navy" }}>Choose your file (for better result .png format with no background only!)</label>
                        <p>
                        </p>
                        <div >
                          <input style={{ color: "navy" }} type="file" id="myFile" accept="png" onChange={handleFileChange} />
                        </div>
                        {priceIn && id && (
                          <div className='FinalItem' style={{ marginTop: "10px" }}>
                            <div>
                              <div>
                                {products.map(product => (
                                  <div key={product.id}>
                                    <Cart product={product} myArr={variants2} show={show} setShow={setShow} size={selectedSize}
                                      color={selectedVariant.Color} thumPrice={selectedThumPrice} thum={selectedThumbnail}
                                      image2={myImage.image}
                                      image={myImage} thumImage={uploadedImage}
                                      thumId={thumId} thumFile={uploadedFileUrl}
                                      forwardRef={ref}
                                      url={selectedVariant.DefaultImageSrc}
                                      rating={0}
                                      Artsize={parseFloat(message.area)*1.5}
                                      salePrice={selectedVariant.SalePrice}
                                      isOnSale={selectedVariant.isOnSale}
                                      weight={selectedVariant.weight}
                                      colorName4API={selectedVariant.colorName4API}
                                      imageSize1={message.width ?? "std"} 
                                      imageSize2={message.height ?? "std"}
                                      imageSize3={message.widthInches?? "std"}
                                      imageSize4={message.heightInches?? "std"}
                                      finalImage={selectedImage}
                                      uploadedImage={uploadedImage}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* <CompatibleSlider currentStyle={style} url={url} path={"product-adult"} /> */}
                    </div>
                  )}

                </>
              )}
            </div>
          </div>
        </>
      )}
      {/* {priceIn && (
          <div className='FinalItem' style={{ marginTop: "10px" }}>
            <div>
              <div>
                {products.map(product => (
                  <div key={product.id}>
                    <Cart product={product} myArr={variants2} show={show} setShow={setShow} size={selectedSize}
                      color={selectedVariant.Color} thumPrice={selectedThumPrice} thum={selectedThumbnail}
                      image2={myImage.image}
                      image={myImage} thumImage={uploadedImage}
                      thumId={thumId}
                      forwardRef={ref}
                      url={selectedVariant.DefaultImageSrc}
                      rating={0}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )} */}


    </div>

  );
};

export default ProductDetailAdult;
// import { useEffect, useState } from 'react';
// import { collection, query, where, getDocs } from 'firebase/firestore';
// import { productDb } from '../firebaseProducts';
// import { useParams, useNavigate } from 'react-router-dom';
// const ProductDetailAdult = ({product}) => {
//   const { style } = useParams();
//   const [variants, setVariants] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [myImage, setMyImage] = useState(null);
//   const [price, setPrice] = useState(null);

//   useEffect(() => {
//     console.log("🔥 useEffect triggered with style:", style);

//     const fetchVariants = async () => {
//       try {
//         console.log("🚀 Fetching from Firestore…");

//         // Ensure style is defined
//         if (!style) {
//           console.error("❌ Style is not defined!");
//           return;
//         }

//         // Construct Firestore query
//         const q = query(
//           collection(productDb, 'adult-apparel'),
//           where('Style', '==', style)
//         );

//         console.log("🧐 Querying with style:", style);

//         // Send the query to Firestore and await response
//         const querySnapshot = await getDocs(q);

//         // Log size of the snapshot
//         console.log("querySnapshot size:", querySnapshot.size);

//         if (querySnapshot.empty) {
//           console.log("⚠️ No matching documents found!");
//         } else {
//           querySnapshot.forEach(doc => {
//             console.log("🔥 Doc:", doc.id, doc.data());
//           });
//         }

//         // Create a filtered list of variants
//         const today = new Date();

//         const filteredVariants = querySnapshot.docs.map((doc) => {
//           const data = doc.data();
//           console.log("📋 Document Data:", data); // Log raw document data

//           // Handle SALE_END_DATE and parse it correctly
//           let endSaleDate = null;
//           if (data.SALE_END_DATE && data.SALE_END_DATE !== '0') {
//             endSaleDate = new Date(data.SALE_END_DATE);
//           }
//           const isOnSale = endSaleDate && endSaleDate >= today;

//           // Parse price and sale price
//           const price = parseFloat(data.Price) || 0;
//           const salePrice = parseFloat(data.PIECE_SALE_PRICE) || 0;
//           let adjustedSalePrice = salePrice;

//           // Adjust sale price if needed
//           if (isOnSale && salePrice > 0) {
//             const discount = price - salePrice;
//             if (discount > 3) adjustedSalePrice = price - 3;
//           }

//           return {
//             Handle: data.Handle,
//             DefaultImageSrc: data.model,  // Assuming 'model' is the correct field
//             HoverImageSrc: data.FRONT_FLAT,
//             FRONT_FLAT: data.FRONT_FLAT,
//             BACK_FLAT: data.BACK_FLAT,
//             FRONT_MODEL: data.FRONT_MODEL,
//             BACK_MODEL: data.BACK_MODEL,
//             SIDE_MODEL: data.SIDE_MODEL,
//             model: data.DefaultImageSrc,
//             front: data.front,
//             back: data.back,
//             ImageSrc: data.ImageSrc,

//             Price: price.toFixed(2),
//             SalePrice: adjustedSalePrice.toFixed(2),
//             isOnSale,
//             EndSale: endSaleDate,
//             Description: data.Body,  // Assuming you want the 'Body' field here
//             Color: data.Color,
//             Size: data.Size,
//             Style: data.Style,
//             Hex: data.Hex,
//             Vendor: data.Vendor,
//             Id: data.id,  // Assuming 'id' is the correct field
//             tag: data.Tags,  // Assuming 'Tags' is the correct field
//             ProductDetail: data.ProductDetail,
//             ProductDecor: data.ProductDecor,
//             weight: data.weight,
//             colorName4API: data.colorName4API,
//             ImageCircle: data.ImageCircle,
//           };
//         });

//         // Set the variants state
//         setVariants(filteredVariants);
//         setLoading(false);

//         // Set selected variant if available
//         if (filteredVariants.length > 0) {
//           setSelectedVariant(filteredVariants[0]);
//           setMyImage(filteredVariants[0].DefaultImageSrc);
//           setPrice(filteredVariants[0].Price);
//         }

//       } catch (err) {
//         console.error("Error fetching variants:", err);
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchVariants();
//   }, [style, productDb]);  // Ensure dependencies are correct

//   // Optionally, render loading, error states, and variants
//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       {/* Display selected variant and image */}
//       <img src={myImage} alt={selectedVariant?.Handle} />
//       <p>{selectedVariant?.Title}</p>
//       <p>Price: ${price}</p>
//     </div>
//   );
// };

// export default ProductDetailAdult;
